import { StrengthConfig, PasswordRule } from "./types";

export const DEFAULT_STRENGTH_CONFIG: StrengthConfig = {
  0: { label: "", bgColor: "", textColor: "" },
  1: { label: "Too Weak", bgColor: "bg-ERROR", textColor: "text-ERROR" },
  2: { label: "Weak", bgColor: "bg-YELLOW", textColor: "text-YELLOW" },
  3: {
    label: "Strong",
    bgColor: "bg-LIGHT_GREEN",
    textColor: "text-LIGHT_GREEN",
  },
  4: { label: "Very Strong", bgColor: "bg-GREEN", textColor: "text-GREEN" },
};

export const DEFAULT_PASSWORD_RULES: PasswordRule[] = [
  {
    id: "specialChar",
    label: "A Symbol",
    test: (pwd: string) => /[!@#$%^&*(),.?":{}|<>/]/.test(pwd),
  },
  {
    id: "uppercase",
    label: "An Uppercase Letter",
    test: (pwd: string) => /[A-Z]/.test(pwd),
  },
  {
    id: "lowercase",
    label: "A Lowercase Letter",
    test: (pwd: string) => /[a-z]/.test(pwd),
  },
  {
    id: "minLength",
    label: "8 Characters Minimum",
    test: (pwd: string) => pwd.length >= 8,
  },
  {
    id: "number",
    label: "A Number",
    test: (pwd: string) => /\d/.test(pwd),
  },
];
